import type {
    CreateQualityStatementRequest,
    CreateQualityStatementResponse,
    QualityStatementTemplateListResponse,
    QualityStatementCommitRequest, QualityStatementCommitResponse,
} from "./types";
import type { AxiosPromise } from "axios";
import { apiClient } from "@/api/modules/base";
import { Route } from "./route";

export const create = (payload: CreateQualityStatementRequest): AxiosPromise<CreateQualityStatementResponse> =>
    apiClient.post(Route.CreateQualityStatement, payload);

export const getTemplates = (): AxiosPromise<QualityStatementTemplateListResponse> =>
    apiClient.get(Route.GetTemplates);

export const commit = (payload: QualityStatementCommitRequest): AxiosPromise<QualityStatementCommitResponse> =>
    apiClient.post(Route.Commit, payload);
